import React, {useState} from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';



function QuestionsAnswers(props) {
    return (
        <div className='section-questions'>
            <ContentArea
            noWrap
            key='QuestionsAndAnswersContentArea'
            context={props.context}
            data={props.epiData.questionsAndAnswersContentArea}
            propertyName='QuestionsAndAnswersContentArea'
            />
        </div>
    );
}

const mapStateToProps = (state) => {
  return {
    epiData: state.equipmentMinePage.epiData
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsAnswers);
